<template>
    <v-responsive v-bind="$attrs" :class="{ 'grey lighten-2': !createObjectURL }" class="text-center" @click="click">
        <v-img v-if="createObjectURL" :src="createObjectURL" v-bind="$attrs"></v-img>
        <v-layout v-else align-center justify-center fill-height><v-icon>mdi-image</v-icon></v-layout>
        <v-file-input v-model="fileInput" ref="fileInput" accept="image/*" class="d-none" @change="input"></v-file-input>
    </v-responsive>
</template>

<script>
export default {
    props: ["value"],
    data() {
        return {
            file: this.$props.value,
            fileInput: null,
        };
    },
    methods: {
        input(file) {
            this.file = file;
            this.fileInput = null;
            this.$emit("input", file);
        },
        click() {
            this.$refs.fileInput.$el.getElementsByTagName("input")[0].click();
        },
    },
    computed: {
        createObjectURL() {
            return this.file ? URL.createObjectURL(this.file) : null;
        },
    },
    watch: {
        value() {
            this.file = this.value;
        },
    },
};
</script>